import { useQuery } from '@zg-rentals/react-query5';
import { allTimestampsOneYear } from '../../../../utils/allTimestampsOneYear';
import {
  AnalyticsNumBedroomType,
  MarketAnalyticsWebApiHandler_getRentPriceAverageByBedroom,
  MarketAnalyticsWebApiHandler_getRentPriceAverageByBedroom_Path,
  ZgSearchHomeType,
} from '@zg-rentals/ts-customer-analytics-client';

export const radioButtonEnum = {
  [AnalyticsNumBedroomType.ALL]: AnalyticsNumBedroomType.ALL,
  [AnalyticsNumBedroomType.STUDIO]: AnalyticsNumBedroomType.STUDIO,
  [AnalyticsNumBedroomType.ONE_BEDROOM]: AnalyticsNumBedroomType.ONE_BEDROOM,
  [AnalyticsNumBedroomType.TWO_BEDROOM]: AnalyticsNumBedroomType.TWO_BEDROOM,
  [AnalyticsNumBedroomType.THREE_BEDROOM]: AnalyticsNumBedroomType.THREE_BEDROOM,
  [AnalyticsNumBedroomType.FOUR_PLUS_BEDROOM]: AnalyticsNumBedroomType.FOUR_PLUS_BEDROOM,
};

export const analyticsNumBedroomTypeToLabelMapping = {
  [AnalyticsNumBedroomType.ALL]: 'All Beds',
  [AnalyticsNumBedroomType.STUDIO]: 'Studio',
  [AnalyticsNumBedroomType.ONE_BEDROOM]: '1 Bed',
  [AnalyticsNumBedroomType.TWO_BEDROOM]: '2 Beds',
  [AnalyticsNumBedroomType.THREE_BEDROOM]: '3 Beds',
  [AnalyticsNumBedroomType.FOUR_PLUS_BEDROOM]: '4+ Beds',
};

const analyticsNumBedroomTypeToNumberMapping = new Map<AnalyticsNumBedroomType, number | undefined>([
  [AnalyticsNumBedroomType.ALL, undefined],
  [AnalyticsNumBedroomType.ONE_BEDROOM, 1],
  [AnalyticsNumBedroomType.TWO_BEDROOM, 2],
  [AnalyticsNumBedroomType.THREE_BEDROOM, 3],
  [AnalyticsNumBedroomType.FOUR_PLUS_BEDROOM, 4],
  [AnalyticsNumBedroomType.STUDIO, 0],
]);

export const useGetMarketData = ({
  regionId,
  bedsFilter,
  propertyType = ZgSearchHomeType.MULTI_FAMILY,
}: {
  regionId: number;
  bedsFilter: AnalyticsNumBedroomType;
  propertyType?: ZgSearchHomeType;
}) => {
  const timestamps = allTimestampsOneYear();
  const startDate = new Date(timestamps[0]);
  const endDate = new Date(timestamps[timestamps.length - 1]);
  const { data, isLoading, error } = useQuery({
    queryKey: [MarketAnalyticsWebApiHandler_getRentPriceAverageByBedroom_Path, { regionId, bedsFilter, propertyType }],
    queryFn: async () =>
      MarketAnalyticsWebApiHandler_getRentPriceAverageByBedroom({
        endDate: {
          year: endDate.getFullYear(),
          month: endDate.getMonth() + 1,
          day: endDate.getDate(),
        },
        startDate: {
          year: startDate.getFullYear(),
          month: startDate.getMonth() + 1,
          day: startDate.getDate(),
        },
        propertyType,
        zillowRegionId: regionId,
        bedrooms: analyticsNumBedroomTypeToNumberMapping.get(bedsFilter),
      }),
    enabled: Boolean(regionId),
  });

  return { data, isLoading, error };
};
